module.exports = __webpack_public_path__ + "static/img/98028A_1_2_C_20240429_fit.06ec015.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/98028A_1_2_C_20240429_fit.png
// module id = 77WO
// module chunks = 0